import { app } from '../../../../../app';
import { Controller } from './widgets.controller';

app.component('companyManageApplicationIntegrationDevelopersWidgets', {
    bindings: {appId: '<'},
    controller: Controller,
    templateUrl: require('./widgets.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/widgets/widgets.component.js